module.exports = __webpack_public_path__ + "static/GoToVerify-c4fddb337f659b6936ec1ce28906b53d.png";